import React from 'react'
import { useHistory } from 'react-router-dom'

import { AcornsIcon, Icon } from '@acorns/icons'

import { PORTFOLIO_EDIT_SUBHEADER } from 'utils/testing/testIDs'

import {
  EditPortfolioListItemButton,
  EditPortfolioListItemChevron,
  EditPortfolioListItemHeader,
  EditPortfolioListItemHeaderContainer,
  EditPortfolioListItemIcon,
  EditPortfolioListItemLeft,
  EditPortfolioListItemSubHeader,
} from './styled-components'

type Props = {
  header: string
  icon: Icon
  url: string
  testId: string
  subHeader?: string
  color?: string
}

const EditPortfolioListItem = ({
  header,
  icon,
  subHeader,
  url,
  testId,
  color,
}: Props) => {
  const history = useHistory()

  const handlePortfolioListButtonClick = () => {
    history.push(url, {
      referrer: history.location.pathname,
    })
  }

  return (
    <EditPortfolioListItemButton
      data-testid={testId}
      onClick={handlePortfolioListButtonClick}
    >
      <EditPortfolioListItemLeft>
        <EditPortfolioListItemIcon icon={icon} />
        <EditPortfolioListItemHeaderContainer>
          <EditPortfolioListItemHeader>{header}</EditPortfolioListItemHeader>
          {subHeader && (
            <EditPortfolioListItemSubHeader
              data-testid={PORTFOLIO_EDIT_SUBHEADER}
            >
              {subHeader}
            </EditPortfolioListItemSubHeader>
          )}
        </EditPortfolioListItemHeaderContainer>
      </EditPortfolioListItemLeft>
      <EditPortfolioListItemChevron
        icon={AcornsIcon.Icon.ChevronRightPortfolio}
        color={color}
      />
    </EditPortfolioListItemButton>
  )
}

export { EditPortfolioListItem }
